import AlertIcon from './AlertIcon.vue'
import DoubleCard from './DoubleCard.vue'
import BlackBtn from './BlackBtn.vue'

export {
  AlertIcon,
  DoubleCard,
  BlackBtn
}
